import React, { useState } from 'react';
import { TextArea, Modal } from 'carbon-components-react';
import CustomButton from '../../../components/custom-button/custom-btn.component';
import { useCustomMutation } from '@/utils/useCustomMutation';
import { postMethod } from '@/api/common';
import Combobox from '../../../components/combobox/Combobox';
import { useDebounceState } from '@/utils/useDebounceState';
import useSWR from 'swr';
import { getQueryString } from '@/utils/common.util';

const GrantExemptionModal = ({ openModal, cancelAction, onSuccess }) => {
  const [studentId, setStudentId] = useState(null);
  const [note, setNote] = useState('');
  const [searchStudent, setSearchStudent] = useDebounceState('');

  const { data: students, isLoading: isStudentsLoading } = useSWR(
    openModal
      ? `student/list?status=Enrolled&${getQueryString({ query: searchStudent })}`
      : null,
  );

  const selectedStudent = students?.find((s) => s.id === studentId) ?? null;

  const { trigger, isMutating, reset, error } = useCustomMutation(
    'report-lock/exemptions',
    (url, { arg }) => postMethod(url, arg),
  );

  const handleSubmit = async () => {
    if (!studentId || !note.trim() || isMutating) return;

    const payload = {
      studentId,
      note: note.trim(),
    };

    await trigger(payload, {
      onSuccess: () => {
        if (onSuccess) onSuccess();
        setStudentId(null);
        setNote('');
        reset();
        cancelAction();
      },
    });
  };

  function handleClose() {
    setStudentId(null);
    setNote('');
    reset();
    cancelAction();
  }

  return (
    <Modal
      id="grant-exemption-modal"
      className="confirm-modal"
      hasScrollingContent
      passiveModal={true}
      open={openModal}
      modalHeading="Grant Exemption"
      primaryButtonDisabled={false}
    >
      <div>
        <Combobox
          options={students ?? []}
          label="Student"
          customStyles={{ width: '100%' }}
          value={selectedStudent}
          onChange={(option) => {
            setStudentId(option ? option.id : null);
          }}
          onSearch={setSearchStudent}
          onClear={() => {
            setStudentId(null);
            setSearchStudent('');
          }}
          loading={isStudentsLoading}
          renderSelected={(option) =>
            option
              ? `${option.firstName} ${option.lastName} - ${option.classDescription}`
              : ''
          }
          renderOption={(option) =>
            `${option.firstName} ${option.lastName} - ${option.classDescription}`
          }
          labelKey="fullName"
          valueKey="id"
          searchPlaceholder="Search students..."
          placeholder="Select a student"
        />

        <div className="mt-20">
          <TextArea
            labelText="Note"
            placeholder="Enter reason for exemption"
            rows={4}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>

        {error && <p className="text-14 mt-10 text-danger">{error?.message}</p>}

        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <CustomButton
            classes="outline no-hover font-bold danger"
            style={{ flex: '1' }}
            disabled={isMutating}
            onClick={handleClose}
          >
            CANCEL
          </CustomButton>

          <CustomButton
            style={{ flex: '1' }}
            classes="font-bold success"
            disabled={!studentId || !note.trim() || isMutating}
            onClick={handleSubmit}
            isLoading={isMutating}
          >
            GRANT EXEMPTION
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default GrantExemptionModal;
